// Регистрация панелей раздела в каркасе. Побочный эффект при загрузке модуля: раздел
// объявляет, что умеет рисовать в стопке панелей, а каркас (PanelStack) остаётся без знания
// о разделах. Импортируется из SitesSection — то есть ровно тогда, когда раздел вообще
// попадает в сборку экрана.

import { registerPanel } from '@/layout/panel-registry';

// Мастер укомплектования лежит в разделе «Люди»: его предмет — назначение, и он тянет за
// собой поля тарифа, справочник статусов и запросы реестра людей. Перенести его сюда значило
// бы перетащить в раздел объектов половину чужого модуля. Регистрирует его тот, кто
// открывает, — иначе панель, открытая из карточки объекта, показала бы заглушку каркаса.
import { StaffPostPanel } from '@/modules/people/panels/StaffPostPanel';

import {
  PANEL_EDIT_CONTRACT,
  PANEL_EDIT_CUSTOMER,
  PANEL_EDIT_POST,
  PANEL_EDIT_SITE,
  PANEL_NEW_CUSTOMER,
  PANEL_NEW_POST,
  PANEL_NEW_SITE,
  PANEL_STAFF_POST,
} from '../route';

import { EditContractPanel } from './EditContractPanel';
import { EditCustomerPanel } from './EditCustomerPanel';
import { EditPostPanel } from './EditPostPanel';
import { EditSitePanel } from './EditSitePanel';
import { NewCustomerPanel } from './NewCustomerPanel';
import { NewPostPanel } from './NewPostPanel';
import { NewSitePanel } from './NewSitePanel';

registerPanel(PANEL_NEW_SITE, {
  title: () => 'Новый объект',
  render: ({ id, onClose }) => <NewSitePanel id={id} onClose={onClose} />,
});

registerPanel(PANEL_EDIT_SITE, {
  title: () => 'Правка объекта',
  render: ({ id, onClose }) => <EditSitePanel id={id} onClose={onClose} />,
});

registerPanel(PANEL_NEW_POST, {
  title: () => 'Новый пост',
  render: ({ id, onClose }) => <NewPostPanel id={id} onClose={onClose} />,
});

registerPanel(PANEL_STAFF_POST, {
  title: () => 'Поставить людей на пост',
  render: ({ id, onClose }) => <StaffPostPanel id={id} onClose={onClose} />,
});

registerPanel(PANEL_NEW_CUSTOMER, {
  title: () => 'Новый заказчик',
  render: ({ onClose }) => <NewCustomerPanel onClose={onClose} />,
});

// Три правки справочника, появившиеся 15.09.2026. До них исправить опечатку в заказчике,
// договоре и посте было нечем: у всех трёх на сервере был только путь «завести», и
// единственным выходом оставалось завести строку заново — то есть оставить двойника.
registerPanel(PANEL_EDIT_CUSTOMER, {
  title: () => 'Правка заказчика',
  render: ({ id, onClose }) => <EditCustomerPanel id={id} onClose={onClose} />,
});

registerPanel(PANEL_EDIT_CONTRACT, {
  title: () => 'Правка договора',
  render: ({ id, onClose }) => <EditContractPanel id={id} onClose={onClose} />,
});

registerPanel(PANEL_EDIT_POST, {
  title: () => 'Правка поста',
  render: ({ id, onClose }) => <EditPostPanel id={id} onClose={onClose} />,
});
